module.exports = __webpack_public_path__ + "img/ic-account-purple.516eda8f.svg";